import apiClient from '../api/client';

export const getAdmins = async () => {
  const { data } = await apiClient.get('/admin/admins');
  return data;
};

export const createAdmin = async ({ name, email, password, role }) => {
  const { data } = await apiClient.post('/admin/admins', { name, email, password, role });
  return data;
};

export const toggleAdmin = async (id) => {
  const { data } = await apiClient.patch(`/admin/admins/${id}/toggle`);
  return data;
};
